import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { getIconByType } from "../../../../libs/documentsUtils";
import { useSelector } from "react-redux";

import FooterCard from "./footerCard";
import WidgetCard from "../../../widget/card";
import { FormattedMessage, useIntl } from "react-intl";
import { FEATURE_TOGGLE_DOCUMENTS_SEARCH_ACCURACY } from "../../../../config";

/**
 * Disegna la card di un widget solitamente la card su DBOX si divide in 3 sul 100% di spazio disponibile
 * usiamo il type per capire in quanto dividere lo spazio es. 1 su 4 colonne oppure 2 su 3 colonne etc..
 * Il default lo etichetterei come box1_3 se voglio dividere per 3 e prendere 1 sola colonna box2_3 se voglio
 * che il box occupi 2 colonne su 3
 */
const CardBlock = props => {
  const { getDownload, handleClick, item } = props;
  const intl = useIntl();
  let infolistFilename = item.infoList
    ? item.infoList.find(el => {
      return el.label === "Nome file";
    })
    : null;
  let filename = infolistFilename
    ? infolistFilename.value
    : item.fileName
      ? item.fileName
      : "unnamed";
  let splitSubtitle = item.subtitle && item.subtitle.split(/ da | a /);
  const documentsTypes = useSelector(state =>
    state.documents && state.documents.classification
      ? state.documents.classification.typesDocuments
      : null);

  return (
    <div
      className="card-block-container"
    >
      <WidgetCard
        footer={
          <FooterCard
            documentId={item.documentId}
            filename={filename}
            getDownload={getDownload}
            handleClick={handleClick}
            isEinvoice={item.isInvoice}
            subtitle={item.subtitle}
            notesCount={item.notesCount}
          />
        }
        isCentered={false}
        onClick={e => handleClick(
          e, item.documentId, item.subtitle
        )}
        titleWidget={null}
        type={"cardbox1_3"}
      >
        <div style={{ padding: "8px" }}>
          <div style={{ display: "flex" }}>
            <div style={{ flex: "1 0 auto" }} className="titleDocumentCard">
              {FEATURE_TOGGLE_DOCUMENTS_SEARCH_ACCURACY === "true" && (
                <p className="searchAccuracy">
                  {" "}
                  <FormattedMessage id="documents.detail.accuracy" />{" "}
                  {Math.round(item.documentSearchScorePercentage)}%{" "}
                </p>
              )}
              <div className="card-block-title" >
                <div style={{ margin: "4px 10px 0 0" }}>
                  <FontAwesomeIcon
                    icon={["far", getIconByType(item.title, documentsTypes)]}
                    style={{ color: "#005075", fontSize: "24px" }}
                  />
                </div>
                <div className="card-block-description" >
                  {item.subtitle ? splitSubtitle[0] : intl.formatMessage({id: "documents.toTranslate." + item.title, defaultMessage: item.title})}
                  {item.subtitle ? (
                    <div
                      className="subtitleCard"
                      style={{ display: item.subtitle ? "block" : "none" }}
                    >
                      {item.subtitle.replace(splitSubtitle[0], "")}
                    </div>
                  ) : null}
                </div>
                {item.visibleByStudioOnly ? (
                  <Tooltip color={"rgb(0, 80, 117)"}
                    placement="top" title={intl.formatMessage({id: "documents.visibleStudioOnly", defaultMessage: "Visibile solo allo studio"})}>
                    <FontAwesomeIcon
                      icon={["far", "minus-hexagon"]}
                      style={{ fontSize: "14px", color: "#d82829" }}
                    />
                  </Tooltip>
                ) : null}
              </div>
            </div>
            <div>
              <FontAwesomeIcon
                icon={["fas", "check-circle"]}
                style={{
                  color: item.read ? "#8bc34a" : "#86899d",
                  fontSize: "24px"
                }}
              />
            </div>
          </div>
          <div style={{ height: "120px", overflow: "auto" }}>
            {item.infoList &&
              item.infoList.map((el,key) => (
                <div key={key} className="detailCard">
                  {el.label} : <b>{el.value}</b>
                </div>
              ))}
            &nbsp;&nbsp;
            {item.encrypted ? (
              <Tooltip color={"rgb(0, 80, 117)"}
                placement="top" title={intl.formatMessage({id: "documents.crypted", defaultMessage: "Documento criptato"})}>
                <FontAwesomeIcon
                  icon={["far", "key"]}
                  style={{ color: "#0090d1", fontSize: "16px" }}
                />
              </Tooltip>
            ) : null}
          </div>
        </div>
      </WidgetCard>
    </div>
  );
};

export default CardBlock;
